import { render, staticRenderFns } from "./product.vue?vue&type=template&id=48495720"
import script from "./product.vue?vue&type=script&lang=ts"
export * from "./product.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports